import { render, staticRenderFns } from "./EvolutionByPhysicianBar.vue?vue&type=template&id=ac6da86c&"
import script from "./EvolutionByPhysicianBar.vue?vue&type=script&lang=js&"
export * from "./EvolutionByPhysicianBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports